import { patchState, signalStore, withHooks, withMethods } from "@ngrx/signals";
import { setAllEntities, setEntity, withEntities } from "@ngrx/signals/entities";
import { setFulfilled, setPending, withRequestStatus } from "../extensions/request-status.feature";
import { inject } from "@angular/core";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { Observable, pipe, switchMap, tap } from "rxjs";
import { ApiAbTestsService } from "../../services/api-ab-tests.service";
import { AbTestViewModel } from "@playcharge/common/models/backend/ab-tests/ab-test-view-model";
import { AbTestEditModel } from "@playcharge/common/models/backend/ab-tests/ab-test-edit-model";

export type AbTestsStore = InstanceType<typeof AbTestsStore>;

export const AbTestsStore = signalStore(
    { providedIn: "root", protectedState: false },
    withEntities<AbTestViewModel>(),
    withRequestStatus(),
    withMethods((store, apiAbTestsService = inject(ApiAbTestsService)) => ({
        loadTests: rxMethod<void>(
            pipe(
                tap(() => patchState(store, setPending())),
                switchMap(() => {
                    return apiAbTestsService.getTests().pipe(
                        tap((tests) => {
                            patchState(store, setAllEntities(tests));
                            patchState(store, setFulfilled());
                        }),
                    );
                }),
            ),
        ),
        createTest(model: AbTestEditModel): Observable<AbTestViewModel> {
            return apiAbTestsService
                .createTest(model)
                .pipe(tap((abTest) => patchState(store, setEntity(abTest))));
        },
        setTest(abTest: AbTestViewModel): void {
            patchState(store, setEntity(abTest));
        },
    })),
    withHooks((store) => ({
        onInit: () => {
            store.loadTests();
        },
    })),
);
